const logsRoute = process.env.VUE_APP_API_ROUTE + '/g_transbank_log'
import axios from 'axios'

//Helper Methods
const getError = e => (e.message ? e.message : e)
const storeLog = ctx => (response, type, id, message, route = null) =>
    axios.post(logsRoute, {
        route: route || ctx._url,
        http_code: response._status || null,
        operation_number: response.operation_number || 0,
        g_transbank_log_type_id: type,
        model_id: parseInt(id),
        message,
    })

const promiseHandler = ctx => (promise, type, id = null, url = null) =>
    new Promise((resolve, reject) => {
        promise
            .then(response =>
                new Promise((resolve, reject) =>
                    response
                        .json()
                        .then(r => {
                            r._status = response.status
                            if (response.status !== 200) reject(r)
                            resolve(r)
                        })
                        .catch(reject)
                ).then(r => {
                    if ([200, 201, 500, 502].includes(r._status))
                        storeLog(ctx)(
                            r,
                            type,
                            id || ctx._cash_desk_id,
                            r.message || null,
                            url
                        )
                    if (r._status && ![200, 201].includes(r._status))
                        reject(getError(r))
                    resolve(r)
                })
            )
            .catch(r => {
                if ([200, 201, 500, 502].includes(r._status))
                    storeLog(ctx)(
                        r,
                        type,
                        id || ctx._cash_desk_id,
                        r.message || null,
                        url
                    )
                reject(getError(r))
            })
    })

const post = ctx => (url, data = {}, type, id = null) =>
    promiseHandler(ctx)(
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' },
        }),
        type,
        id,
        url
    )
//End Helper Methods

class TBK {
    /*
     * Pass tbk service api url
     */
    constructor(serviceUrl, cashDeskID = 1) {
        this._url = serviceUrl
        this._post = post(this)
        this._cash_desk_id = cashDeskID
    }

    poll() {
        return new Promise((resolve, reject) => {
            fetch(this._url + 'poll')
                .then(response => {
                    console.log(response, response.status, 1)
                    response
                        .json()
                        .then(r => {
                            if (response.status !== 200) reject(r.message)
                            if(!r.success) reject('No conectado a maquina POS')
                            resolve(r.success)
                        })
                        .catch(e => reject(e.message ? e.message : e))
                })
                .catch(e => {
                    console.log(e, 3)
                    reject(e.message ? e.message : e)
                })
        })
    }

    sale(ticket_number, amount, type = 1) {
        ticket_number += ''
        if (ticket_number.length < 6)
            ticket_number = ticket_number.padStart(6, 0)
        if (ticket_number.length > 6)
            ticket_number = ticket_number
                .split('')
                .reverse()
                .slice(0, 6)
                .reverse()
                .join('')
        return this._post(
            this._url + 'sale',
            { ticket_number, amount },
            type,
            ticket_number
        )
    }

    reprint() {
        return this._post(this._url + 'last_sale', null, 4)
    }

    refund(operation_number) {
        return this._post(this._url + 'refund', { operation_number }, 4)
    }

    total() {
        return this._post(this._url + 'total', null, 4)
    }

    saleDetails(print_on_pos = true) {
        return this._post(
            this._url + 'sale_details',
            {
                // Only accepts true for now, fix later
                print_on_pos: print_on_pos || true,
            },
            4
        )
    }

    loadKeys() {
        return this._post(this._url + 'load_key', null, 4)
    }

    normalMode() {
        return this._post(this._url + 'normal_mode', null, 4)
    }

    close() {
        return this._post(this._url + 'close', null, 4)
    }
}

export default TBK
